import React, { useState,Component, useEffect } from 'react';
import StockListOne from './StockListOne';
import './StockTradingApp.css';
import { Container, Row, Col, Card, Button, Form } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import axios from "axios";
import {  useNavigate } from "react-router-dom";
import { toast } from 'react-toastify';
import investment_url from '../../APIs/Investment-api';
import transaction_api from '../../APIs/Transaction-api';
import NavBar from '../NavBar/NavBar';
import { useUser } from '../../context/UserContext';
import axiosInstance from '../../axiosInstance';
import user_auth_api from '../../APIs/user-auth-api';
import LogOutMessage from '../LogoutMessage/LoggedOut';
import {
  Typography,
  TableContainer,
  styled,
} from '@mui/material';

const InvestContainer=styled(TableContainer)(({ theme }) => ({
  margin: '20px auto',
  padding: '20px',
  border: '1px solid #ccc',
  borderRadius: '8px',
  boxShadow: '0 0 10px rgba(0, 0, 0, 0.1)',
  width: '90%',
    [theme.breakpoints.down('sm')]: {
    padding: '20px 0px 0px 0px',
    width: '95%',
  },
}));


function StockTradingApp(){
  const {userData} =useUser();
  const isLoggedIn =  userData !== null ? true : false;
  const [balance, setBalance] = useState(); 
  useEffect(()=>{
    window.scrollTo({ top: 0, behavior: 'smooth' });
    if(isLoggedIn){
    axiosInstance.get(`${user_auth_api}/users/${userData.id}`)
    .then((response)=>{
      setBalance(response.data.currentBalance.toFixed(2));
    })
  }
  },[balance]);
  const user_id = isLoggedIn ? userData.id : -1;
  const userBalance = isLoggedIn ? userData.currentBalance : -1;
  // console.log(userBalance);
  const navigate = useNavigate();

  const currentDate = new Date();
  currentDate.setTime(currentDate.getTime() + 5.5 * 60 * 60 * 1000);
  const [selectedStock, setSelectedStock] = useState(null);
  const [quantity, setQuantity] = useState(1); // Default quantity
  const [qunatityError, setQunatityError] = useState('');
  const isQuantityValid = quantity >= 1;

  const handlePost = async(type ,newBalancea, status) =>{
    await axios.post(transaction_api,{
        "user_id" : user_id,
        "type" : type,
        "amount" : quantity * selectedStock.price.toFixed(2),
        "closingBalance" : newBalancea,
        "quantity" : quantity,
        "transactionDate" : currentDate,
        "stockSymbol" : selectedStock.symbol,
        "status" : status
      }).then((response)=>{
        // navigate("/Dashboard");
      })
     
    }

  const handleStockSelect = (stock) => {
    setSelectedStock(stock);
    window.scrollTo({ top: 0, behavior: 'smooth' }); // Scroll to the top
  };

  const handleQuantityChange = (event) => {
    const { value } = event.target;
    setQuantity( value); 
    if (parseFloat(value) <= 0) {
      setQunatityError('Please enter valid quantity');
    } else {
      setQunatityError('');
    }
  };

  const handleBuyStock = async(price) => {
    const amount = quantity * price;
    if (balance >= amount) { 
      const StockDetails={
      user_id : user_id,
      stock_symbol:selectedStock.symbol,
      buy_price:selectedStock.price,
      current_price:selectedStock.price,
      quantity,
      company_name:selectedStock.company,
    };

  
    axios.post(`${investment_url}/investments`,StockDetails)
    .then((response) =>{
      if(response.status===200){
        toast.success('Bought Stock Successfully', { position: 'top-right',
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: true, });
      } else{
        toast.error('Error buying in stock', { position: 'top-right',
          autoClose: 2000,
          hideProgressBar: true,
          closeButton: true,});
      }
    })
    .catch((error) => {
      console.error('Error at investment api call in stock details:',error);
      toast.error('Error !',{position: 'top-right',
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: true,})
    }) ;
  };


    if (balance >= amount) { // Update balance and perform other actions (e.g., add the stock to the user's portfolio)
      const newBalance = balance - quantity * price;
      setBalance(newBalance);
      handlePost('Buy' , newBalance, 'success');
      axiosInstance.patch(`${user_auth_api}/users/balance/${user_id}`,{
        "currentBalance" : newBalance
      }).then((response)=>{
      })
      setSelectedStock(null);
    } else {
      handlePost('Buy' , balance, 'failed');
      toast.error('Insufficient balance to buy this stock', { position: 'top-right',
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: true, });
    }
    setQuantity(1);
  
}

const handleSellStock = async (price) => {
  try {
    const newBalance = parseFloat(balance) + quantity * price;
    const stockDetailsCopy = {
      user_id:user_id,
      stock_symbol: selectedStock.symbol,
      buy_price: selectedStock.price,
      current_price: selectedStock.price,
      quantity: 0,
      company_name: selectedStock.company,
    };
    const responseCopy = await axios.post(`${investment_url}/investments`, stockDetailsCopy);
    if (isNaN(responseCopy.data.quantity)||responseCopy.data.quantity<quantity) {
      handlePost('Sell', balance, 'failed');
      toast.error('Stock not available', { position: 'top-right',
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: true,});
    }
    else if (responseCopy.status === 200) {
      setBalance(newBalance);
      stockDetailsCopy.quantity = -quantity;
      await axios.post(`${investment_url}/investments`, stockDetailsCopy);
      handlePost('Sell', newBalance, 'success');
      axiosInstance.patch(`${user_auth_api}/users/balance/${user_id}`,{
        "currentBalance" : newBalance
      }).then((response)=>{
      })
      toast.success('Stock sold !!', {position: 'top-right',
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: true, });
    } 
     else {
      toast.error('Error selling stock !!', { position: 'top-right',
        autoClose: 2000,
        hideProgressBar: true,
        closeButton: true,});
      console.error('Failed to update stock:', responseCopy.data);
    }

    
  } catch (error) {
    console.error('An error occurred:', error);
    alert('An error occurred');
  }
    setSelectedStock(null);
    setQuantity(1);
};

  return (
    <>
    {isLoggedIn ? (
    <>


<NavBar heding="Invest"/>

<InvestContainer>

<Typography
  variant="h5"
  align="center"
  gutterBottom
  sx={{
    backgroundColor: '#5a287d',
    color: 'white',
    padding: '10px',
    marginBottom: '25px',
    '@media (max-width:600px)': {
      margin: '0px 10px 25px 10px',
    },
  }}
>
  Stock Trading
</Typography>

{/* <div className="header">
    <h1>Stock Trading</h1>
</div> */}
     <Container className="stock-trading-app  mx-auto">
      <p style={{fontWeight:'bold'}}>Current Balance: ${balance}</p>
      
     <Row>
       <Col>
         {selectedStock && (
          <Card className="selected-stock" style={{marginTop :'0px' , marginBottom :'40px'}}>
          <Card.Header className='selected-stock-header'><h4>{selectedStock.company}</h4></Card.Header>
          <Card.Body>
            <Card.Title>{selectedStock.symbol}</Card.Title>
            <Card.Text>
            Price: ${selectedStock.price.toFixed(2)}
            </Card.Text>
            <Form>
      
        <Form.Group >
        <Row className= "quantityForm"> 
        <Col className="pr-2" >
                      <Form.Group>
                        <label className="lable-style" >Enter Quantity (To Buy/Sell)</label>
                        <Form.Control 
                          type="number"
                          value={quantity}
                          onChange={handleQuantityChange}
                          className= "mx-auto"
                          style={{ width: window.innerWidth < 768 ? '50%' : '25%' }}
                        ></Form.Control>
                        <Form.Text className="text-danger">{qunatityError}</Form.Text>
                      </Form.Group>
                    </Col>
          </Row>
        </Form.Group>
            </Form>
                   <Button
                   className="buttonNatwest" 
                     onClick={() => handleBuyStock(selectedStock.price.toFixed(2))}
                     disabled={!isQuantityValid}
                   >
                     Buy
                   </Button>
                   <Button
                  className="buttonNatwest" 
                     onClick={() => handleSellStock(selectedStock.price.toFixed(2))}
                     disabled={!isQuantityValid}
                   >
                     Sell
                   </Button>
          </Card.Body>
         </Card>
         )}
       </Col>
     </Row>
     <Row>
       <Col>
         <StockListOne onStockSelect={handleStockSelect} balance={balance} />
       </Col>
     </Row>
   </Container>
   </InvestContainer>
   </>
    ) : (
      <>
    <LogOutMessage/>
      </>
    )}
    </>
  );
}


export default StockTradingApp;